<template>
  <div>
    <a-row>
      <g-master :name="master.endpoint"
                :endpoint="master.endpoint"
                :tableSetup="master.tableSetup"
                :modalFieldsSetup="master.modalFieldsSetup"
                :parentData="parentData"
                modalWidth="60%"
      >
        <template slot="masterModal" slot-scope="{record}">
          <a-row :gutter="[16,16]">
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Nombre')">
                <a-input
                  v-decorator="['nombre', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Nombre Equivalente')">
                <a-input
                  v-decorator="['nombre_equivalente', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <g-dropdown endpoint="nm_estructuras"
                          :label="$t('Estructura a enlazar')"
                          :formItemConfig="fiOptions"
                          :cache="false"
                          :decorator="['estructura_enlazada_id', { rules: [{ required: false }] }]">
              </g-dropdown>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Estado')">
                <a-checkbox
                  v-decorator="['activo', {valuePropName: 'checked',  rules: [{ required: false }]}]">
                </a-checkbox>
              </a-form-item>
            </a-col>
          </a-row>
        </template>
      </g-master>
    </a-row>
  </div>
</template>

<script>
  export default {
    props: ['estructura_id'],
    data () {
      return {
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          endpoint: 'nomelect_nodos',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: '#', dataIndex: 'id', sorter: true},
              {title: 'Nombre', dataIndex: 'nombre', sorter: true},
              {title: 'Equivalencia Nombre', dataIndex: 'nombre_equivalente', sorter: true},
              {title: 'Estructura Enlazada', dataIndex: 'estructura_enlazada_desc', sorter: true},
              {title: 'Estado', dataIndex: 'active_desc', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'nombre'},
            {name: 'nombre_equivalente'},
            {name: 'estructura_enlazada_id'},
            {name: 'activo', type: 'boolean'}
          ]
        }
      }
    },
    computed: {
      parentData () {
        return {
          estructura_id: this.estructura_id
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/NomElect/NomElectNodos.vue